module.exports = __webpack_public_path__ + "img/tabbed-search-filter-v-search-bar-dark.b4dd30f2.png";